import axiosInstance from "../../_utils/axiosConfig";

export const customer = async ()=>{
    try{
       const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/customer`);
       return response.data;
    }catch(error){
         console.log("Erreur lots de l'appel a l'API")
    }
} 